import { useSelectedStudentIdContext } from "#/components/exam-results/context/studentsList/context";
import { getModule, getTopic } from "#/utils/legacyData/cache/generateHelper";
import { Tooltip } from "@monta/design-system";
import clsx from "clsx";
import { useCallback } from "react";
import type { DqGlobalProps } from "../types";
import { useGetQuestions } from "../utils";
import styles from "./dqHeader.module.scss";

export const QuestionTopic = (props: DqGlobalProps) => {
  const { id } = props;
  const { selectedStudentId } = useSelectedStudentIdContext();
  const { topics } = useGetQuestions(selectedStudentId, id)[0];

  const topicBarGenerator = useCallback(() => {
    const parsedTopics = JSON.parse(topics ?? "{}")?.idList ?? [];
    const topicBar: string[] = [];

    let currentTopic = getTopic(parsedTopics[0]?.id);

    while (currentTopic) {
      topicBar.unshift((currentTopic?.name ?? "").trim());
      if (!currentTopic.parentTopicId) {
        topicBar.unshift((getModule(currentTopic.moduleId)?.name ?? "").trim());
        break;
      }
      currentTopic = getTopic(currentTopic.parentTopicId);
    }

    return topicBar;
  }, [topics]);

  const topicBar = topicBarGenerator();

  const shrinkCondition = topicBar.length > 3;

  const barData = shrinkCondition
    ? [topicBar[0], "...", topicBar[topicBar.length - 1]]
    : topicBar;

  const BaseComponent = (
    <ol className={styles["topic"]}>
      {barData.map((name, index) => {
        return (
          <li
            key={index}
            className={clsx(
              styles[`topic__layer-${index + 1}`],
              shrinkCondition && styles[`topic__layer-${index + 1}__tooltip`],
            )}
          >
            {name}
          </li>
        );
      })}
    </ol>
  );

  if (!shrinkCondition)
    return <div className={styles["topic__container"]}>{BaseComponent}</div>;

  return (
    <div className={styles["topic__container"]}>
      <Tooltip text={topicBar.slice(1).join(" | ")}>{BaseComponent}</Tooltip>
    </div>
  );
};
